import React from 'react';
import SectionHeader from '../SectionHeader';
import EmptyState from '../EmptyState';
import EntryCard from '../EntryCard';
import { motion } from 'framer-motion';

const TAB_INFO = {
  all: { label: 'Everything', desc: 'Everything your group has added to the world.' },
  kith: { label: 'Custom Kith', desc: 'Companions, creatures, and folk beyond the core rules.' },
  place: { label: 'Places', desc: 'Locations visited, named, and remembered.' },
  session: { label: 'Journey Notes', desc: 'What happened, who was there, what was said.' },
  rule: { label: 'House Rules', desc: 'The agreements and moves that make this table yours.' },
};

export default function EntriesTab({ entries, activeTab, onOpenModal, onEditEntry, onRefresh }) {
  const visibleEntries = activeTab === 'all' ? entries : entries.filter(e => e.type === activeTab);
  const info = TAB_INFO[activeTab] || TAB_INFO.all;

  return (
    <div>
      <SectionHeader 
        title={info.label} 
        description={info.desc} 
        buttonText="Add Entry"
        onButtonClick={onOpenModal} 
      />

      {visibleEntries.length === 0 ? (
        <EmptyState icon="📖" title="Nothing here yet." hint="Be the first to add something." />
      ) : (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(270px,1fr))] gap-6 pl-4">
          {visibleEntries.map((entry, i) => (
            <motion.div 
              key={entry.id}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.2, delay: i * 0.05 }}
            >
              <EntryCard 
                entry={entry} 
                onEdit={() => onEditEntry(entry)} 
                onRefresh={onRefresh}
              />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}